import RemoteSelect from "common/components/RemoteSelect/RemoteSelect";
import usePark from "common/hooks/usePark";
// import { Specy } from "types/Specy";

const processOptions = (options: any[]) =>
  options.map(({ id, name, scientificName }) => ({
    value: id,
    label:
      scientificName && name
        ? `${scientificName} (${name})`
        : scientificName ?? name,
  }));

function SpecySelect(props: any) {
  const { park } = usePark();

  return (
    <RemoteSelect
      url="species"
      processOptions={processOptions}
      filters={[{ name: "park", value: park?.id }]}
      {...props}
    />
  );
}

export default SpecySelect;
